import React, {Component} from 'react';
import './Actions.css';
import Button from './Button';

class Actions extends Component {
	render() {
		const {disabled, disabledActions = [], isDirty = false, actions, positive, onClick} = this.props;
		
		return (
			<div className={`Actions ${isDirty ? 'dirty' : ''}`}>
				{actions.map(action => (
					<Button
						key={action}
						disabled={disabled || (disabledActions && disabledActions.indexOf(action) >= 0)}
						className={`Actions-button ${positive === action ? 'positive' : 'negative'}`}
						onClick={(onClick && !disabled) ? () => onClick(action) : undefined}
					>{action}</Button>
				))}
			</div>
		);
	}
}

export default Actions;


// WEBPACK FOOTER //
// ./src/widgets/Actions.js